import { formattingLocale } from "@webdo/i18n";

export function formatDateTime(value: string | Date, locale: string): string {
  return new Intl.DateTimeFormat(formattingLocale(locale), {
    dateStyle: "medium",
    timeStyle: "short",
  }).format(new Date(value));
}

export function formatDate(value: string | Date, locale: string): string {
  return new Intl.DateTimeFormat(formattingLocale(locale), {
    dateStyle: "medium",
  }).format(new Date(value));
}

export function formatDecimal(value: number, locale: string): string {
  return new Intl.NumberFormat(formattingLocale(locale)).format(value);
}

export function formatMoney(value: string | number, locale: string, currency = "CZK"): string {
  const numericValue = typeof value === "number" ? value : Number(value);

  return new Intl.NumberFormat(formattingLocale(locale), {
    style: "currency",
    currency,
    maximumFractionDigits: 0,
  }).format(Number.isFinite(numericValue) ? numericValue : 0);
}
